export default __webpack_public_path__ + "static/media/Commandes_Modifier.e31d1a01.png";